import * as tslib_1 from "tslib";
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import TaskDocumentList from './TaskDocumentList';
import FileUpload from './FileUpload';
import TaskDocumentTypes from './TaskDocumentTypes';
import { DOCUMENT_DELETE_ERROR } from 'src/constants/errors';
import { DOCUMENT_DELETED } from 'src/constants/messages';
import { TextField } from 'material-ui';
import BusyIndicator from 'src/components/BusyIndicator';
import TabContent from 'src/layout/TabContent';
var dropdownStyle = {
    margin: '1rem'
};
var TaskDocuments = /** @class */ (function (_super) {
    tslib_1.__extends(TaskDocuments, _super);
    function TaskDocuments(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTypeChange = function (type) {
            _this.props.store.selectDocumentType(type);
        };
        _this.handleFileSelected = function (file) {
            _this.setState({ selectedFile: file });
        };
        _this.handleUpload = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.store.uploadDocument(this.state.selectedFile, this.state.description)];
                    case 1:
                        _a.sent();
                        this.setState({
                            selectedFile: null,
                            description: ''
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleClear = function () {
            _this.setState({
                selectedFile: null,
                description: ''
            });
        };
        _this.handleDocumentDelete = function (document) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var deleteAllowed, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deleteAllowed = window.confirm("Biztosan t\u00F6rli a k\u00F6vetkez\u0151 csatolm\u00E1nyt: \"" + document.name + "\" ?");
                        if (!deleteAllowed) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.store.deleteDocument(document.id)];
                    case 1:
                        result = _a.sent();
                        this.props.userStore.notify(result ? DOCUMENT_DELETED : DOCUMENT_DELETE_ERROR);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            description: '',
            selectedFile: null
        };
        return _this;
    }
    TaskDocuments.prototype.componentWillMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.store.loadDocuments()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskDocuments.prototype.render = function () {
        var _this = this;
        var _a = this.props.store, visibleDocuments = _a.visibleDocuments, selectedDocumentType = _a.selectedDocumentType;
        var upload = selectedDocumentType === 0
            ? null
            : (React.createElement(FileUpload, { selectedFile: this.state.selectedFile, onChange: this.handleFileSelected, onUpload: this.handleUpload, onClear: this.handleClear }));
        var description = !!this.state.selectedFile
            ? React.createElement(TextField, { style: { margin: '1rem' }, hintText: "Megjegyz\u00E9s", multiLine: true, fullWidth: true, value: this.state.description, onChange: function (e, value) { return _this.setState({ description: value }); } })
            : null;
        return (React.createElement(BusyIndicator, { active: this.props.store.isBusy, size: 20 },
            React.createElement("div", { style: dropdownStyle },
                React.createElement(TaskDocumentTypes, { documentStore: this.props.store, selectedType: selectedDocumentType, onTypeChanged: this.handleTypeChange })),
            React.createElement(TabContent, null,
                React.createElement(TaskDocumentList, { documents: visibleDocuments, onDelete: this.handleDocumentDelete }),
                upload,
                description)));
    };
    TaskDocuments = tslib_1.__decorate([
        inject('userStore'),
        observer
    ], TaskDocuments);
    return TaskDocuments;
}(React.Component));
export default TaskDocuments;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskDocuments.tsx
// module id = 735
// module chunks = 0